import React, { useEffect, useState } from "react";
import axios from "axios";
import { connect } from "react-redux";

import { fetchThemes, addThemeThumb } from "../core/redux/api/themes";

import Icon from "./Icons";

import { l } from "../functions";

import GKEvent from "../events";
import { TextField } from "./FormElements";

import RemoveDialog from "./RemoveDialog";
import ThemeChangeDialog from "./ThemeChangeDialog";
import { ajaxUri } from "../consts/index";
import ImageUploader from "./ImageUploader";
import Switch from "@material-ui/core/Switch";

const mapStateToProps = (state) => {
  return {
    fetchedThemes: state.rootReducer.fetchedThemes || {},
    themeThumbList: state.rootReducer.themeThumbList || {},
    currentTheme: state.rootReducer.currentTheme || null,
    appearanceSettings: state.rootReducer.appearanceSettings || {},
  };
};

const themeNaming = (filename) => {
  if (filename) return filename.split("_").join(" ").replace(".json", "");

  return "";
};

const themeUNaming = (filename) => {
  return filename.split(" ").join("_") + ".json";
};
// class ThemesPalette extends Component {
//   constructor(props) {
//     super(props);

//     this.defaultState = {
//       removingTheme: null,
//       themesNames: {},
//       creatingTheme: false,
//       changingTheme: null,
//       newThemeName: "",
//     };

//     this.tabLabel = {
//       1: "basic",
//       2: "imported",
//       3: "my_themes",
//     };

//     this.state = {
//       ...this.defaultState,
//       ...{ currentTab: this.tabLabel[this.props.currentTab] },
//     };
//   }

//   componentWillReceiveProps({ currentTab }) {
//     if (currentTab !== this.props.currentTab) {
//       this.setState({
//         currentTab: this.tabLabel[currentTab],
//       });
//     }
//   }

//   _confirmDeleteTheme = (theme) => {
//     this.setState({
//       removingTheme: theme,
//     });
//   };

//   _renameTheme = (key, value) => {
//     this.setState({
//       ...this.state,
//       themesNames: {
//         ...this.state.themesNames,
//         [key]: value,
//       },
//     });
//   };

//   _deleteTheme = () => {
//     axios({
//       method: "post",
//       url: ajaxUri,
//       data: {
//         request: "deleteTheme",
//         type: this.state.currentTab,
//         filename: this.state.removingTheme,
//       },
//     })
//       .then((result) => {
//         if (result.data.status === "success")
//           this.setState(this.defaultState, () => {
//             this.props.fetchThemes();
//           });

//         GKEvent.notification(result.data.status, result.data.message);
//       })
//       .catch((error) => {
//         GKEvent.notification(
//           "error",
//           l("Error while deleting the page settings. Please try again.")
//         );
//       });
//   };

//   _saveThemeName = (index, key, value) => {
//     axios({
//       method: "post",
//       url: ajaxUri,
//       data: {
//         request: "renameTheme",
//         type: this.state.currentTab,
//         theme: key,
//         name: themeUNaming(value),
//       },
//     })
//       .then((result) => {
//         if (result.data.status === "success") {
//           delete this.state.themesNames[key];
//           this.props.fetchThemes();
//         }

//         GKEvent.notification(result.data.status, result.data.message);
//       })
//       .catch((error) => {
//         GKEvent.notification(
//           "error",
//           l("Error while deleting the theme. Please try again.")
//         );
//       });
//   };

//   _loadTheme = (theme, cb = () => {}) => {
//     axios({
//       method: "post",
//       url: ajaxUri,
//       data: {
//         request: "loadTheme",
//         type: this.state.currentTab,
//         filename: theme,
//       },
//     })
//       .then((result) => {
//         GKEvent.notification(result.data.status, result.data.message);

//         if (result.data.status === "success") {
//           cb();

//           setTimeout(() => {
//             window.location.reload();
//           }, 5000);
//         }
//       })
//       .catch((error) => {
//         GKEvent.notification(
//           "error",
//           l("Error while deleting the theme. Please try again.")
//         );
//       });
//   };

//   _downloadTheme = (theme) => {
//     axios({
//       method: "post",
//       url: ajaxUri,
//       data: {
//         request: "downloadTheme",
//         filename: theme,
//       },
//       responseType: "blob", // important
//     })
//       .then((result) => {
//         const url = window.URL.createObjectURL(new Blob([result.data]));
//         const link = document.createElement("a");

//         link.href = url;
//         link.setAttribute("download", theme); //or any other extension
//         document.body.appendChild(link);
//         link.click();
//       })
//       .catch((error) => {
//         GKEvent.notification(
//           "error",
//           l("Error while deleting the theme. Please try again.")
//         );
//       });
//   };

//   _saveTheme = (themeToReplace = null) => {
//     const name = themeToReplace || themeUNaming(this.state.newThemeName);

//     axios({
//       method: "post",
//       url: ajaxUri,
//       data: {
//         request: "saveTheme",
//         filename: name,
//       },
//     })
//       .then((result) => {
//         GKEvent.notification(result.data.status, result.data.message);

//         if (result.data.status === "success") {
//           this.setState(this.defaultState, () => {
//             this.props.fetchThemes();
//           });
//         }
//       })
//       .catch((error) => {
//         GKEvent.notification(
//           "error",
//           l("Error while saving the theme. Please try again.")
//         );
//       });
//   };

//   _themeListing = (loop, readOnly = false) => {
//     let themes = [];

//     this.props.fetchedThemes[loop] &&
//       this.props.fetchedThemes[loop].forEach((theme, index) => {
//         const themeName =
//           this.state.themesNames[theme] !== undefined
//             ? this.state.themesNames[theme]
//             : themeNaming(theme);

//         let actions = [
//           {
//             label: l("Load this theme"),
//             action: () => {
//               this.setState({ changingTheme: theme });
//             },
//           },
//         ];

//         if (loop !== "basic")
//           actions.push({
//             label: l("Delete this theme"),
//             action: () => {
//               this._confirmDeleteTheme(theme);
//             },
//           });

//         if (this.state.currentTab === "my_themes")
//           actions.push(
//             {
//               label: l("Save in existing theme"),
//               action: () => {
//                 this._saveTheme(theme);
//               },
//             },
//             {
//               label: l("Download this theme"),
//               action: () => {
//                 this._downloadTheme(theme);
//               },
//             }
//           );

//         let rename;
//         if (readOnly) rename = false;
//         else
//           rename = {
//             label: l("Rename theme"),
//             onChange: this._renameTheme,
//             onSave: this._saveThemeName,
//           };

//         themes.push(
//           <List
//             key={index}
//             itemKey={theme}
//             draggable={false}
//             rename={rename}
//             content={[themeName, l("my new theme")]}
//             actions={actions}
//             onClick={() => {}}
//           />
//         );
//       });

//     return themes;
//   };

//   _importTheme = (event) => {
//     if (event.target.files[0]) {
//       const currentFile = event.target.files[0];
//       const data = new FormData();
//       data.append("file", currentFile);
//       data.append("request", "uploadTheme");

//       axios
//         .post(ajaxUri, data, {
//           // receive two    parameter endpoint url ,form data
//         })
//         .then((result) => {
//           // then print response status
//           GKEvent.notification(result.data.status, result.data.message);

//           if (result.data.status === "success") {
//             this.setState(this.defaultState, () => {
//               this.props.fetchThemes();
//             });
//           }
//         });
//     }
//   };

//   render() {
//     return (
//       <div className="palette-tab">
//         <ul className="tab-head">
//           {/* <li className={this.state.currentTab === 'basic'?'active':''} onClick={() => {this.setState({currentTab:'basic'})}}>{l('Classic')}</li> */}
//           <li
//             className={this.state.currentTab === "imported" ? "active" : ""}
//             onClick={() => {
//               this.setState({ currentTab: "imported" });
//             }}
//           >
//             {l("Imported")}
//           </li>
//           <li
//             className={this.state.currentTab === "my_themes" ? "active" : ""}
//             onClick={() => {
//               this.setState({ currentTab: "my_themes" });
//             }}
//           >
//             {l("My themes")}
//           </li>
//         </ul>
//         <ul className="tab-body">
//           <RemoveDialog
//             open={this.state.removingTheme}
//             onConfirm={this._deleteTheme}
//             onClose={() => {
//               this.setState(this.defaultState);
//             }}
//             title={l("You are deleting a theme ?")}
//           />

//           <ThemeChangeDialog
//             open={this.state.changingTheme}
//             loadTheme={() => {
//               this._loadTheme(this.state.changingTheme, () => {
//                 this.setState({ changingTheme: null });
//               });
//             }}
//             closeDialog={() => {
//               this.setState({ changingTheme: null });
//             }}
//           />
//           {this.state.currentTab === "basic" && (
//             <li>{this._themeListing("basic", true)}</li>
//           )}
//           {this.state.currentTab === "imported" && (
//             <li>
//               {this._themeListing("imported", true)}
//               <button
//                 className="new-item"
//                 onClick={() => {
//                   document.getElementById("uploadfield").click();
//                 }}
//               >
//                 <span>
//                   <BackupIcon />
//                 </span>
//               </button>
//               <div className="upload-theme">
//                 <input
//                   id="uploadfield"
//                   type="file"
//                   name="file"
//                   onChange={this._importTheme}
//                 />
//               </div>
//             </li>
//           )}
//           {this.state.currentTab === "my_themes" && (
//             <li>
//               {this._themeListing("my_themes")}

//               <div className="new-theme">
//                 {this.state.creatingTheme && (
//                   <div className="section">
//                     <label className="small">{l("Theme name")}</label>
//                     <TextField
//                       value={this.state.newThemeName}
//                       onChange={(value) => {
//                         this.setState({ newThemeName: value });
//                       }}
//                       dark
//                     />
//                   </div>
//                 )}

//                 <button
//                   className="new-item"
//                   onClick={() => {
//                     if (this.state.creatingTheme) {
//                       if (this.state.newThemeName !== "") this._saveTheme();
//                       else this.setState({ creatingTheme: false });
//                     } else this.setState({ creatingTheme: true });
//                   }}
//                   disabled={
//                     this.state.creatingTheme &&
//                     !validName(this.state.newThemeName) &&
//                     this.state.newThemeName !== ""
//                   }
//                 >
//                   {(this.state.creatingTheme &&
//                     ((this.state.newThemeName === "" && (
//                       <Icon icon="time" />
//                     )) || (
//                       <span>
//                         <SaveIcon />
//                       </span>
//                     ))) || <Icon icon="plus" />}
//                 </button>
//               </div>
//             </li>
//           )}
//         </ul>
//       </div>
//     );
//   }
// }

class ThemesPalette extends React.Component {
  constructor(props) {
    super(props);
    this.defaultState = {
      fetchedThemes: this.props.fetchedThemes || {},
      currentThemeName: themeNaming(this.props.currentTheme) || null,
      savingTheme: false,
      themeName: "",
      currentDropDown: null,
      currentTab: 1,
      defaultThemes: [1, 2, 3],
      changing: null,
      themeToLoad: null,
      themeType: null,
      showLoader: null,
      removingTheme: null,
      type: null,
      currentThemeThumb:
        this.props.appearanceSettings["themeImage"]?.path ||
        "https://www.wikihow.com/images/thumb/8/83/Design-a-Website-Step-1-Version-12.jpg/v4-460px-Design-a-Website-Step-1-Version-12.jpg.webp",
    };
    this.tabLabel = {
      1: "basic",
      2: "imported",
      3: "my_themes",
    };
    this.state = {
      ...this.defaultState,
    };
  }
  componentWillReceiveProps(nextProps) {
    const {
      basic = [],
      imported = [],
      my_themes = [],
    } = nextProps.fetchedThemes;
    const {
      basic: pBasic = [],
      imported: pImported = [],
      my_themes: pMyThemes = [],
    } = this.state.fetchedThemes;

    if (
      basic?.length !== pBasic?.length ||
      imported?.length !== pImported?.length ||
      my_themes?.length !== pMyThemes?.length
    ) {
      this.setState({ fetchedThemes: nextProps.fetchedThemes || {} });
    }
  }

  _confirmDeleteTheme = (theme, type) => {
    this.setState({
      removingTheme: theme,
      type,
    });
  };

  _deleteTheme = () => {
    axios({
      method: "post",
      url: ajaxUri,
      data: {
        request: "deleteTheme",
        type: this.state.type,
        filename: this.state.removingTheme,
      },
    })
      .then((result) => {
        if (result.data.status === "success")
          this.setState(this.defaultState, () => {
            this.props.fetchThemes();
          });

        GKEvent.notification(result.data.status, result.data.message);
      })
      .catch((error) => {
        GKEvent.notification(
          "error",
          l("Error while deleting the page settings. Please try again.")
        );
      });
  };

  _dropDown = (current) => {
    if (this.state.currentDropDown === current) {
      this.setState({ currentDropDown: null });
    } else {
      this.setState({ currentDropDown: current });
    }
  };
  _loadTheme = (cb = () => {}) => {
    this.setState({ changing: true, showLoader: true });

    axios({
      method: "post",
      url: ajaxUri,
      data: {
        request: "loadTheme",
        type: this.state.themeType,
        filename: this.state.themeToLoad,
      },
    })
      .then((result) => {
        GKEvent.notification(result.data.status, result.data.message);
        if (result.data.status === "success") {
          cb();

          setTimeout(() => {
            window.location.reload();
          }, 5000);
        }
      })
      .catch((error) => {
        this.setState({ showLoader: null });
        GKEvent.notification(
          "error",
          l("Error while loading the theme. Please try again.")
        );
      });
  };

  _getThemeThumbnail = () => {};

  _saveTheme = (themeName) => {
    axios({
      method: "post",
      data: {
        request: "saveTheme",
        filename: themeUNaming(themeName),
      },
      url: ajaxUri,
    })
      .then((result) => {
        GKEvent.notification(result.data.status, result.data.message);

        if (result.data.status === "success") {
          this.setState(this.defaultState, () => {
            this.props.fetchThemes();
          });
          // window.location.reload();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  _updateImage = (path) => {
    axios({
      url: ajaxUri,
      method: "post",
      data: {
        request: "setThemeTumb",
        groupName: "themeImage",
        value: JSON.stringify({ path: path }),
      },
    }).then(() => {
      //do some after this
    });
  };

  _importTheme = (event) => {
    if (event.target.files[0]) {
      const currentFile = event.target.files[0];
      const data = new FormData();
      data.append("file", currentFile);
      data.append("request", "uploadTheme");
      let fileData = "";
      const reader = new FileReader();
      reader.readAsText(currentFile, "UTF-8");
      reader.onload = (event) => {
        fileData = event.target.result;
      };

      axios
        .post(ajaxUri, data, {
          // receive two    parameter endpoint url ,form data
        })
        .then((result) => {
          // then print response status
          GKEvent.notification(result.data.status, result.data.message);

          if (result.data.status === "success") {
            this.setState(this.defaultState, () => {
              this.props.fetchThemes();
            });
          }
        });
    }
  };

  callBack = () => {
    this.setState({
      changing: null,
      themeToLoad: null,
      themeType: null,
      showLoader: null,
    });
  };

  render() {
    const { currentThemeName, fetchedThemes, savingTheme } = this.state;
    const {
      basic: basicThemes,
      imported: importedThemes,
      my_themes: myThemes,
    } = fetchedThemes;
    const { showCustomize } = this.props;
    return (
      <>
        {/* <div className="theme-loader"></div> */}
        <div className="palette-tab">
          <div className="tabs-side">
            <h1>Themes</h1>
            <ul>
              <li
                onClick={() => this.setState({ currentTab: 1 })}
                className={this.state.currentTab == 1 ? "active" : ""}
              >
                My Themes
              </li>
              <li
                onClick={() => this.setState({ currentTab: 2 })}
                className={this.state.currentTab == 2 ? "active" : ""}
              >
                Basic
              </li>
            </ul>
          </div>

          <div className="tab-body theme-block-list content-side">
            <div className="head">
              <h1>
                {this.state.currentTab === 1 ? "My Themes" : "Basic Themes"}
              </h1>
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="none"
                  viewBox="0 0 24 24"
                  onClick={() => this.props.closeEvent()}
                >
                  <path
                    stroke="#A4A8C0"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-miterlimit="10"
                    stroke-width="1.5"
                    d="M18.118 17h-7.53M20 12.168H4.941M18.118 7h-7.53M6.51 14.823L4 11.913l2.51-2.894"
                  ></path>
                </svg>
              </div>
            </div>
            <button style={{ display: "none" }}>
              <div className="upload-theme">
                <input
                  id="uploadfield"
                  type="file"
                  name="file"
                  onChange={this._importTheme}
                />
              </div>
            </button>

            <RemoveDialog
              open={this.state.removingTheme}
              onConfirm={this._deleteTheme}
              onClose={() => {
                this.setState(this.defaultState);
              }}
              title={l("Warning!")}
            />

            <ThemeChangeDialog
              open={this.state.changing}
              payload={{
                themeName: this.state.themeToLoad,
                type: this.state.themeType,
                cb: this.callBack,
              }}
            />

            {this.state.currentTab == 1 && (
              <>
                {savingTheme && (
                  <div className="save-theme">
                    <div className="save-dialog">
                      <h1>Details of your new theme</h1>
                      <button
                        className="icon-div"
                        onClick={() => {
                          this.setState({ savingTheme: !savingTheme });
                        }}
                      >
                        <Icon icon="time" />
                      </button>
                      <ImageUploader
                        onChange={this._updateImage}
                        buttonText="Choose preview"
                      />
                      <div className="section">
                        <label className="small">{l("Theme name")}</label>
                        <TextField
                          value={this.state.themeName}
                          onChange={(value) => {
                            this.setState({ themeName: value });
                          }}
                          dark
                        />
                      </div>
                      <button
                        onClick={() => {
                          this._saveTheme(this.state?.themeName);
                        }}
                        className="save-button gk-button gk-small gk-primary gk-default"
                      >
                        Save as Theme
                      </button>
                    </div>
                  </div>
                )}
                <div className="theme-block active-theme">
                  <div className="theme-thumb">
                    <Icon icon="check" />

                    <img
                      src={this.state.currentThemeThumb}
                      alt="Theme Thumbnail"
                    />
                  </div>
                  <div className="theme-actions">
                    <button
                      onClick={() => {
                        showCustomize();
                        this.props.closeEvent();
                      }}
                    >
                      Customize
                    </button>
                    <button
                      onClick={() => this.setState({ savingTheme: true })}
                    >
                      Save as Theme
                    </button>
                  </div>
                  <span className="theme-name">
                    {currentThemeName || "Current Theme"}
                  </span>
                </div>

                {myThemes?.map((item, index) => {
                  return (
                    <ThemeBlock
                      themeName={item}
                      type={"my_themes"}
                      deleteTheme={() => {
                        this._confirmDeleteTheme(item, "my_themes");
                      }}
                      dispatchThemeThumb={this.props.addThemeThumb}
                      themeThumbList={this.props.themeThumbList}
                      loadTheme={() => {
                        this.setState({
                          changing: true,
                          themeToLoad: item,
                          themeType: "my_themes",
                        });
                      }}
                    />
                  );
                })}

                <>
                  {importedThemes?.map((item, index) => {
                    return (
                      <ThemeBlock
                        themeName={item}
                        type={"imported"}
                        deleteTheme={() => {
                          this._confirmDeleteTheme(item, "imported");
                        }}
                        dispatchThemeThumb={this.props.addThemeThumb}
                        themeThumbList={this.props.themeThumbList}
                        loadTheme={() => {
                          this.setState({
                            changing: true,
                            themeToLoad: item,
                            themeType: "imported",
                          });
                        }}
                      />
                    );
                  })}
                  <div className="import-btn">
                    <button
                      className=" gk-button gk-small gk-primary gk-default"
                      onClick={() => {
                        document.getElementById("uploadfield").click();
                      }}
                    >
                      Import new theme
                    </button>
                  </div>
                </>
              </>
            )}
            {this.state.currentTab == 2 && (
              <>
                {basicThemes?.map((item, index) => {
                  return (
                    <ThemeBlock
                      themeName={item}
                      type={"basic"}
                      canExport={false}
                      dispatchThemeThumb={this.props.addThemeThumb}
                      themeThumbList={this.props.themeThumbList}
                      loadTheme={() => {
                        this.setState({
                          changing: true,
                          themeToLoad: item,
                          themeType: "basic",
                        });
                      }}
                    />
                  );
                })}
              </>
            )}
          </div>

          {/* <button className="new-item">import</button> */}
        </div>
      </>
    );
  }
}

export default connect(mapStateToProps, { fetchThemes, addThemeThumb })(
  ThemesPalette
);

const ThemeBlock = (props) => {
  const {
    canExport = true,
    themeName = "",
    thumbUrl = "",
    loadTheme = () => {},
    type = "",
    deleteTheme = () => {},
    themeThumbList = {},
    dispatchThemeThumb = () => {},
  } = props;
  const [imageUrl, setImageUrl] = useState(thumbUrl);

  useEffect(() => {
    getThemeImage();
  });

  const getThemeImage = () => {
    if (
      typeof themeThumbList === "object" &&
      !themeThumbList?.hasOwnProperty(themeName)
    ) {
      axios({
        method: "post",
        url: ajaxUri,
        data: {
          request: "getThemeThumb",
          themename: themeName,
          type: type,
        },
      })
        .then((res) => {
          if (res.data) {
            dispatchThemeThumb(themeName, res.data.themeImage?.path);
            setImageUrl(res.data.themeImage?.path);
          } else {
            dispatchThemeThumb(themeName, null);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      setImageUrl(themeThumbList[themeName]);
    }
  };

  const handleExport = () => {
    axios({
      method: "post",
      url: ajaxUri,
      data: {
        request: "downloadTheme",
        filename: themeName,
        type: type,
      },
      responseType: "blob", // important
    })
      .then((result) => {
        const url = window.URL.createObjectURL(new Blob([result.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", themeName); //or any other extension
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        GKEvent.notification(
          "error",
          l("Error Downloading the theme. Please try again.")
        );
      });
  };

  return (
    <div className="theme-block">
      <div className="theme-thumb">
        <img
          src={
            imageUrl ||
            "https://www.wikihow.com/images/thumb/8/83/Design-a-Website-Step-1-Version-12.jpg/v4-460px-Design-a-Website-Step-1-Version-12.jpg.webp"
          }
          alt="Theme Thumbnail"
        />
      </div>
      <div className="theme-actions">
        <button onClick={loadTheme}>Use as Current</button>
        {canExport && (
          <div>
            <button className="export" onClick={handleExport}>
              Export
            </button>
            <button className="delete" onClick={deleteTheme}>
              Delete
            </button>
          </div>
        )}
      </div>
      <span className="theme-name">
        {themeNaming(themeName) || "Default Theme"}
      </span>
    </div>
  );
};
